import React from "react";
import { ReactElement } from "react";

export default function Hilfe(): ReactElement {
   return (<React.Fragment>Hilfe</React.Fragment>);
}